import React from "react";

interface SearchProps {
  color?: string;
  className?: string;
  onClick?: () => void;
  size?: number | string;
}

const Search: React.FC<SearchProps> = ({
  size = 24,
  className,
  onClick,
  color = "#F7F9F9",
}) => {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M17.5 16.6667L13.875 13.0417M15.8333 8.33334C15.8333 12.0152 12.8486 15 9.16667 15C5.48477 15 2.5 12.0152 2.5 8.33334C2.5 4.65144 5.48477 1.66667 9.16667 1.66667C12.8486 1.66667 15.8333 4.65144 15.8333 8.33334Z"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Search;
